import * as THREE from "three";

export const RFD_HUD_COMPASS_ID = "$$rfd-hud-compass";

export const CONFIG = {
  scale: 50,
  clipWidthSideMargin: 200,
  topMargin: 40,
  topMarginBelowToolbar: 30,
  bgOpacity: 0.4,
  bgWidth: 20,
  bgHeight: 0.8,
  renderOrder: 1000,
};

//  This clipping plane cuts the compass in half (front and back)
/**
 * The clippingPlane is used in order to hide the tick marks in front of the origin.
 * In other words, we are viewing the inside of a cylinder as it rotates.
 */
export const SPLIT_COMPASS_CLIPPING_PLANE = new THREE.Plane(new THREE.Vector3(0, 0, -1), -2.5);
